module.exports = __webpack_public_path__ + "img/thumbnail_Babirusa_m_normal.11b8b1bc.png";